import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class GroupIDetailLevelService {

	constructor(private readonly http : HttpClient, private readonly constantService : ConstantsService) { }

	loadDataDetailLevel(periodId, kpiId, alarmId, isCompleted, isIgnored): Observable<any> {
		return this.http
			.get(`${this.constantService.baseAPIURL}/giGroupIDetails/${periodId}/${kpiId}/${alarmId}/${isCompleted}/${isIgnored}`, this.constantService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	saveRowsDetailLevel(kpiId, comment, tableSelectedRows, alarm_id) {
		const InData  = {
			kpiId: Number(kpiId),
			comments: comment,
			groupISaveDetailsDTO: tableSelectedRows,
			alarmId: alarm_id
		}
		return this.http.post(`${this.constantService.baseAPIURL}/giGroupIDetails/save`, InData, { headers: this.constantService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	verificationStatus(status) {
		const GroupI_WidgetsData = JSON.parse(localStorage.getItem("GroupI_WidgetsData"));
		const kpiId = Number(GroupI_WidgetsData.id_KPI)
		const round = Number(GroupI_WidgetsData.id_Round)
		const tierPosition = Number(GroupI_WidgetsData.id_TierPosition)
		const periodId = localStorage.getItem("selectedPeriodId");
		const updateStatusObj = {
			periodId: Number(periodId),
			tierPosition: Number(tierPosition),
			round: Number(round),
			kpiId: Number(kpiId),
			statusId: Number(status)
		}
		return this.http.put(`${this.constantService.baseAPIURL}/gidetails/updateVerificationStatus/save`, updateStatusObj, { headers: this.constantService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateStatus(status) {
		const GroupI_WidgetsData = JSON.parse(localStorage.getItem("GroupI_WidgetsData"));
		const kpiId = Number(GroupI_WidgetsData.id_KPI)
		const round = Number(GroupI_WidgetsData.id_Round)
		const tierPosition = Number(GroupI_WidgetsData.id_TierPosition)
		const periodId = localStorage.getItem("selectedPeriodId");
		const updateStatusObj = {
			periodId: Number(periodId),
			tierPosition: Number(tierPosition),
			round: Number(round),
			kpiId: Number(kpiId),
			statusId: Number(status)
		}
		return this.http.put(`${this.constantService.baseAPIURL}/gidetails/updateStatus/save`, updateStatusObj, { headers: this.constantService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}

}